var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 28 36",
    fill: "#DC1928",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7085 27.3333C15.5418 27.3333 17.0418 25.8333 17.0418 24C17.0418 22.1667 15.5418 20.6667 13.7085 20.6667C11.8751 20.6667 10.3751 22.1667 10.3751 24C10.3751 25.8333 11.8751 27.3333 13.7085 27.3333ZM23.7085 12.3333H22.0418V9C22.0418 4.40001 18.3085 0.666672 13.7085 0.666672C9.10846 0.666672 5.37512 4.40001 5.37512 9V12.3333H3.70846C1.87512 12.3333 0.375122 13.8333 0.375122 15.6667V32.3333C0.375122 34.1667 1.87512 35.6667 3.70846 35.6667H23.7085C25.5418 35.6667 27.0418 34.1667 27.0418 32.3333V15.6667C27.0418 13.8333 25.5418 12.3333 23.7085 12.3333ZM8.54179 9C8.54179 6.15 10.8585 3.83334 13.7085 3.83334C16.5585 3.83334 18.8751 6.15 18.8751 9V12.3333H8.54179V9ZM23.7085 32.3333H3.70846V15.6667H23.7085V32.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.387ebf9826370dcb93f6191b99b3f48d.svg";
export { ForwardRef as ReactComponent };